const PROJECT_ID = import.meta.env.VITE_SUPABASE_PROJECT_ID;
const FN_BASE = `https://${PROJECT_ID}.supabase.co/functions/v1/download-pdf`;

/**
 * Build a tracked download URL for a guide.
 * The edge function logs the hit, then 302 redirects to the actual PDF.
 *
 * @param slug    Guide slug (must match the whitelist in the edge function).
 * @param source  Where the click came from (e.g. "journal", "email", "7-signs-page").
 */
export function pdfDownloadUrl(slug: string, source: string): string {
  return `${FN_BASE}/${slug}?source=${encodeURIComponent(source)}`;
}